import { render, staticRenderFns } from "./CovidCasesMay16To22.vue?vue&type=template&id=185640b6&scoped=true"
import script from "./CovidCasesMay16To22.vue?vue&type=script&lang=js"
export * from "./CovidCasesMay16To22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185640b6",
  null
  
)

export default component.exports